/* ============================================================
   Steps — synchronized thumb + content sliders (How to Start)
   ------------------------------------------------------------
   Two Swiper 11 instances kept in sync via the Thumbs module:
     · [data-steps-thumbs]  — vertical thumb slider (Contact Us,
       Project Strategy and Roadmap, Project Onboarding). Hidden on
       mobile via steps.css.
     · [data-steps-content] — content slider (title, description,
       CTA, image) with Prev/Next arrows overlaying the image and
       looping autoplay.

   Because the content Swiper receives the thumbs Swiper through
   `thumbs.swiper`, a single mechanism keeps everything in sync:
   clicking a thumb, using the arrows, and autoplay all move the
   content slide AND update the active thumb. Swiper is `import`ed
   from the npm ESM build so esbuild tree-shakes in only the modules
   we register (Navigation, Thumbs, Autoplay).
   ============================================================ */
import Swiper from "swiper";
import { Navigation, Thumbs, Autoplay, EffectFade } from "swiper/modules";

export function initSteps() {
  document.querySelectorAll("[data-steps]").forEach(function (root) {
    const thumbsEl = root.querySelector("[data-steps-thumbs]");
    const contentEl = root.querySelector("[data-steps-content]");
    if (!contentEl) return;

    // Left thumb slider — vertical, all thumbs visible, no autoplay/loop.
    // `watchSlidesProgress` is required for the Thumbs module to track and
    // highlight the active thumb; the observers keep it measured correctly
    // when it toggles between hidden (mobile) and visible (tablet/desktop).
    const thumbsSwiper = thumbsEl
      ? new Swiper(thumbsEl, {
          direction: "vertical",
          slidesPerView: "auto",
          spaceBetween: 0,
        })
      : null;

    // Right content slider — fade animation, looping autoplay, arrow
    // navigation, synced to the thumbs slider.
    new Swiper(contentEl, {
      modules: [Navigation, Thumbs, EffectFade],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      rewind: true,
      navigation: {
        prevEl: contentEl.querySelector("[data-steps-prev]"),
        nextEl: contentEl.querySelector("[data-steps-next]"),
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  });
}
